<template>
  <div class="bid-query">
    <div class="bid-top">
      <div class="bid-top-left">
        <el-input class="select" v-model="form.supplierCode" placeholder="供应商编码" clearable />
        <el-input class="select" v-model="form.supplierNameLike" placeholder="供应商名称" clearable />
        <MSelect
        class="select"
          :optionNum="'SU_SUPPLIER_BID_STATUS'"
          placeholder="应标状态"
          :value="form.supplierBidStatusList"
          :filterable="true"
          multiple
          collapse-tags
          @input="getBidStatus"
        ></MSelect>
        <span class="btn-span" v-has="'02010022'"><el-button class="bigData-btn-bidQuery-search" type="primary" @click="searchList" :loading="loadSearch">查询</el-button></span>
        <span class="btn-span" v-has="'02010023'"><el-button class="bigData-btn-bidQuery-push" type="primary"
        v-if="loginState.syntheticalScore==='Y'"  :loading="loadPull" :disabled="isPullBtn?false:true" @click="openPull">推送评分任务</el-button></span>
        <span class="btn-span" v-has="'02010024'"><el-button class="bigData-btn-bidQuery-fqbj" type="primary" :loading="loadOffer" :disabled="isOfferBtn?false:true"
            @click="offerBtn">发起报价</el-button>
            <sapn v-if="fqbjTipsCount" class="fqbjTipsCount">
                若供应商应标成功数少于{{ fqbjTipsCount }}，则无法发起报价
            </sapn>
        </span>
      </div>
      <div class="bid-top-right">
        <el-tooltip effect="dark" content="导出" placement="bottom" v-has="'02010025'">
          <mExport
            :url="exportURl"
            :params="exportParams"
            :name="exporttName"
          ><span class="bigData-btn-bidQuery-export" slot="button-name">导出</span></mExport>
        </el-tooltip>
      </div>
    </div>
    <div class="bid-table">
      <el-table border :data="tableData" height="30" v-loading="loadSearch">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="supplierCode" label="供应商编码" width="230" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="supplierName" label="供应商名称" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="_supplierStatus" label="供应商状态" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="_businessTypeName" label="业务类型" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="registerCapital" label="注册资金(万元)" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="contactName" label="联系人" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="contactEmail" label="邮箱" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="contactNumber" label="联系电话" width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="supplierBidStatusText" label="应标状态" width="140" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isQuotationText" label="是否已报价" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="isNewSupplier" label="" width="140">
            <template v-slot:header="scope">
                <span>是否新供应商</span>
                <el-tooltip class="item" effect="dark" placement="bottom">
                        <div slot="content">
                            <div>1、零担干线公司新供应商定义：供应商处于无合同状态的，或凡供应商签署运输的业务合同（含生效及终止状态）的首个生效时间与报名创建时间的差值未满 12 个月（＜365天），均视为新供应商；否则属于老供应商。</div>
                            <div>2、其他公司新供应商定义：历史未曾与安得有过合作的供应商为新供应商（历史不存在生效或者终止的合同）。</div>
                        </div>
                        <i class="el-icon-question"></i>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column prop="tenderUserCodeList" label="供应商报价账号" width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" min-width="200">
          <template slot-scope="scope" class="action">
            <span v-has="'02010074'"><el-button class="action-btn" size="mini" type="text" @click="uploadBidFunc(scope.row)"
                v-if="scope.row.supplierBidStatus === '5' || scope.row.supplierBidStatus === '6'">应标文件上传</el-button></span>
            <span v-has="'02010075'"><el-button class="action-btn" size="mini" type="text" @click="uploadFileFunc(scope.row)"
                v-if="scope.row.supplierBidStatus === '12'">中标价格表上传</el-button></span>
            <span v-has="'02010027'"><el-button class="action-btn" size="mini" v-if="scope.row.supplierBidStatus==='1'&&loginState.bidStatus * 1 >= 30&&loginState.bidStatus * 1 <= 80"
            @click="signUpEdit(scope.$index, scope.row)" type="text">报名审核</el-button></span>
           <span v-has="'02010028'"><el-button class="action-btn" size="mini" v-if="scope.row.stampStatus==='Y'" @click="handlefile(scope.$index, scope.row)" type="text">应标文件</el-button></span>
           <span><el-button class="action-btn" size="mini" v-if="scope.row.supplierBidStatus==='1'" @click="signUpReject(scope.$index, scope.row)" type="text">报名驳回</el-button></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="应标文件信息" :visible.sync="fileSeal" width="60%" close-on-click-modal>
        <el-table :data="fileData" height="300" style="width: 100%">
            <el-table-column prop="fileName" label="名称" width="250" align="center"></el-table-column>
            <el-table-column prop="moduleNo" label="编号" width="280" align="center"></el-table-column>
            <el-table-column prop="fileId" label="文件ID" width="100" align="center"></el-table-column>
            <el-table-column prop="createUserName" label="创建人" width="200" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
            <el-table-column  prop="action" label="操作" align="center" width="200">
                <template slot-scope="scope" class="action">
                    <!-- <span v-has="'02010070'" class="btn-del"><el-button size="mini" @click="preview(scope.$index, scope.row)" type="text">预览</el-button></span> -->
                    <span class="btn-del"><el-button size="mini" @click="preview(scope.$index, scope.row)" type="text">预览</el-button></span>
                    <span v-has="'02010071'" class="btn-del"><el-button size="mini" @click="download(scope.$index, scope.row)" type="text">下载</el-button></span>
                </template>
            </el-table-column>
        </el-table>
    <div class="dialog-footer-box">
        <el-pagination
                class="text-right"
                @size-change="fileSizeChange"
                @current-change="fileCurrentChange"
                :current-page="page.pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="page.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="page.totalCount"></el-pagination>
        <el-button class="fileClose" @click="fileClose">关 闭</el-button>
    </div>
    </el-dialog>
    <el-pagination
        class="text-right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.pageNo"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"></el-pagination>
    <uploadBidding :MDialogshow="isShowUploadBidding" :rowBidDialogData="rowBidDialogData" @mdialogFn="mdialogFn"></uploadBidding>
    <uploadFile :MDialogshow="isShowUploadFile" :uploadFile="'中标价格表上传'" :rowBidDialogData="rowBidDialogData" @mdialogFn="mdialogFn"></uploadFile>
  </div>
</template>
<script>
import mExport from '@/components/awesome/page/fileHandle/export';
import MSelect from '@/components/lots/otpSelect2';
import { filePreview } from '@/utils/filePreview.js';
import { mapGetters } from 'vuex';
import { bidList, bidDocument, signUpToE, supplierType, uploadBid, isQualified, isExamine, singReject } from '../../../api/supplierBid.js';
import { pullGrade, offerGrade } from '../../../api/gradeResult';
import { seachIspull } from '../../../api/bidScheme';
import { dictWithUrl } from '@/components/lots/api';
import uploadFile from './uploadFile.vue';
import uploadBidding from './uploadBidding.vue';
import { getSysControlParamByCode } from '../../../api/toDo/sysParamsConfig.js'
export default {
    components: { MSelect, mExport, uploadBidding, uploadFile },
    data() {
        return {
            isShowUploadBidding: false,
            isShowUploadFile: false,
            rowBidDialogData: {},
            loadSearch: false,
            loadOffer: false,
            loadPull: false,
            bidData: '', // 编码状态
            isPullBtn: '', // 推送评分按钮状态
            isOfferBtn: '', // 发起报价按钮状态
            isPullGrade: '', // 是否已经推送评分
            dictData: {}, // 数字字典
            form: {
                supplierCode: '',
                supplierNameLike: '',
                supplierBidStatusList: [],
                flag: '1',
                pageNo: 1,
                pageSize: 10
            },
            totalCount: 0,
            tableData: [],
            page: {
                pageSize: 10,
                pageNo: 1,
                totalCount: 0
            },
            supplierCode: '', // 弹窗传输的编码
            fileSeal: false,
            fileData: [],
            exportURl: '/api-srm-web/bid/export/bidSupplier',
            exporttName: '应标文件.xlsx',
            exportParams: {},
            iflowId: this.$route.query.mbpmFlowId,
            // 供应商状态数据
            typeForm: {
                signUp: 0,
                money: 0,
                sucess: 0
            },
            fqbjTipsCount: 0, // 发起报价按钮提示文案
        };
    },
    mounted() {
        // 数字字典转换
        //业务类型 businessTypeList 字典 SRM_BUSYNESS_TYPE_BACKGROUND
        dictWithUrl('SU_SUPPLIER_BID_STATUS,SRM_YES_NO,SRM_BUSYNESS_TYPE_BACKGROUND,SYS_SUPPLIERS_STATUS').then(res => {
            this.dictData = res.data;
            this.init();
            getSysControlParamByCode({ controlCode: 'BID_FIRSTTENDER_SUPPLIER_LEAST_NUM' }).then(res => {
            if (res && +res.code === 0) {
                    this.fqbjTipsCount = res.data || 0
                }
            })
        });
    },
    methods: {
        // 应标文件上传弹窗回调
        mdialogFn() {
            this.isShowUploadBidding = false;
            this.isShowUploadFile = false;
            this.init();
        },
        uploadBidFunc(row) {
            this.isShowUploadBidding = true;
            this.rowBidDialogData = row;
        },
        uploadFileFunc(row) {
            this.isShowUploadFile = true;
            this.rowBidDialogData = row;
        },
        // 上传应标文件
        async uploadEdit(file, row) {
            const res = await uploadBid({
                bidNo: row.bidNo,
                supplierCode: row.supplierCode,
                flId: file.data.data.id,
                downUrl: file.data.data.downUrl,
                fileName: file.data.data.localFileName
            });
            if (res && res.code === '0') {
                this.$message({
                    showClose: true,
                    message: '上传成功',
                    type: 'success'
                });
                this.init();
            }
        },
        // 应标文件
        async handlefile(index, row) {
            this.fileSeal = true;
            this.supplierCode = row.supplierCode;
            this.popupReq();
        },
        // 弹窗请求
        async popupReq() {
            const res = await bidDocument({
                bidNo: this.$route.query.bidNo,
                supplierCode: this.supplierCode,
                ...this.page
            });
            if (res && res.code === '0') {
                this.fileData = res.data.list;
                this.page.totalCount = res.data.totalCount;
            }
        },
        // 应标文件弹窗关闭按钮
        fileClose() {
            this.fileSeal = false;
        },
        // 文件下载
        download(index, row) {
            const files = document.createElement('a');
            files.setAttribute('download', '');
            files.href = row.fileUrl;
            files.click();
        },
        // 预览
        preview(index, row) {
            filePreview(row);
        },
        // 报名审核
        async signUpEdit(index, row) {
            const supplierRes = await isQualified({ supplierCode: row.supplierCode, businessType: this.loginState.businessType });// 校验供应商是否合格
            if (!supplierRes) { return; }
            const examineRes = await isExamine({ supplierCode: row.supplierCode, accountCode: this.loginState.accountEntity });// 校验会计主体是否合格
            if (supplierRes && supplierRes.code === '0' && examineRes && examineRes.code === '0') { // 合格
                const res = await signUpToE({
                    bidNo: row.bidNo,
                    id: row.id
                });
                if (res && res.code === '0') {
                    this.$message.success('操作成功');
                    this.init();
                }
            }
        },
        // 报名驳回
        async signUpReject(index, row) {
            const res = await singReject({ bidNo: row.bidNo, id: row.id });
            if (res && res.code === '0') {
                this.$message.success('操作成功');
                this.init();
            }
        },
        // 推送评分
        openPull() {
            this.$confirm(
                `报名供应商有${this.typeForm.signUp}个，投标成功${this.typeForm.sucess}个，已缴纳保证金但应标文件未盖章${this.typeForm.money}个，是否要推送评分任务?评分任务推送后，其他供应商不能再继续应标`,
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            )
                .then(async () => {
                    this.loadPull = true;
                    const res = await pullGrade({ bidNo: this.$route.query.bidNo });
                    this.loadPull = false;
                    if (res && res.code === '0') {
                        this.$message({
                            type: 'success',
                            message: '推送评分成功!'
                        });
                        this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                        this.fnBidData();
                    }
                }).catch(() => {});
        },
        // 发起报价
        offerBtn() {
            this.$confirm(
                `请查看参与招标的供应商是否为应标成功，目前报名供应商有${this.typeForm.signUp}个，投标成功${this.typeForm.sucess}个，已缴纳保证金但应标文件未盖章${this.typeForm.money}个，是否要发起轮次报价?发起轮次报价后，供应商不能再应标`,
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            )
                .then(async () => {
                    this.loadOffer = true;
                    const res = await offerGrade({ bidNo: this.$route.query.bidNo });
                    this.loadOffer = false;
                    if (res && res.code === '0') {
                        this.$message({
                            type: 'success',
                            message: '发起报价成功!'
                        });
                        this.isOfferBtn = false;// 发起报价成功就把按钮置灰
                        this.$store.dispatch('getGeneAction', { bidNo: this.$route.query.bidNo, iflowId: this.iflowId });
                        this.fnBidData();
                    }
                }).catch(() => {});
        },
        async init() {
            const res = await bidList({
                bidNo: this.$route.query.bidNo,
                iflowId: this.iflowId,
                ...this.form
            }).catch(err => {});
            this.loadSearch = false;
            if (res && res.code === '0') {
                this.tableData = res.data.list;
                this.conversionData(this.tableData);
                this.totalCount = res.data.totalCount;
            }
            this.exportParams = {
                bidNo: this.$route.query.bidNo,
                tenantCode: this.currentTenant.tenantCode,
                ...this.form
            }
            delete this.exportParams.flag
            delete this.exportParams.pageNo
            delete this.exportParams.pageSize
            this.fnBidData();
        },
        async fnBidData() {
            // 供应商应标状态请求数据
            const res = await supplierType({ bidNo: this.$route.query.bidNo });
            if (res && res.code === '0') {
                this.typeForm.signUp = res.data.supplierCodeList.length;// 报名供应商
                this.typeForm.money = res.data.marginPay; // 已缴纳保证金但应标文件未盖章
                this.typeForm.sucess = res.data.bidSucceedNo;// 投标成功
            }
            this.bidData = this.loginState;// 标书状态
            const date = new Date(this.bidData.depositEndTime.replace(' ', 'T')); // 系统返回的时间
            const time = date.getTime();
            var timestamp = new Date().getTime(); // 获取的当前时间
            // 查看是否已经推送评分
            const graderes = await seachIspull(this.$route.query.bidNo);
            if (graderes && graderes.code === '0') {
                this.isPullGrade = graderes.data;
            }
            if (this.bidData.bidStatus === '30' && timestamp - time > 0 && this.isPullGrade === 'N' && this.typeForm.sucess * 1 > 0) {
                this.isPullBtn = true;
            } else {
                this.isPullBtn = false;
            }
            // 发起报价按钮状态
            if (this.bidData.syntheticalScore === 'Y' && this.isPullGrade === 'Y' && this.bidData.bidStatus === '43' && this.typeForm.sucess * 1 > 0) {
                this.isOfferBtn = true;
            } else if (this.bidData.syntheticalScore === 'N' && this.bidData.bidStatus === '30' && this.typeForm.sucess * 1 > 0) {
                this.isOfferBtn = true;
            } else {
                this.isOfferBtn = false;
            }
        },
        conversionData(list) {
            list.map(item => {
                item.supplierBidStatusText = this.dictData.SU_SUPPLIER_BID_STATUS[item.supplierBidStatus];
                item.isQuotationText = this.dictData.SRM_YES_NO[item.isQuotation];

                if (typeof item.businessTypeList === 'string' && item.businessTypeList.includes(',')) {
                    let businessTypeList = item.businessTypeList.split(',')
                    let businessTypeAll = []
                    for (const businessTypeItem of businessTypeList) {
                        let businessTypeName = this.dictData.SRM_BUSYNESS_TYPE_BACKGROUND[businessTypeItem] //业务类型 businessTypeList 字典 SRM_BUSYNESS_TYPE_BACKGROUND
                        businessTypeAll.push(businessTypeName)
                    }
                    item._businessTypeName = businessTypeAll.join(',')
                } else {
                    item._businessTypeName = this.dictData.SRM_BUSYNESS_TYPE_BACKGROUND[item.businessTypeList] //业务类型 businessTypeList 字典 SRM_BUSYNESS_TYPE_BACKGROUND
                }

                item._supplierStatus = this.dictData.SYS_SUPPLIERS_STATUS[item.supplierStatus];
            });
            return list;
        },
        // 查询
        searchList() {
            this.loadSearch = true;
            this.form.pageNo = 1;
            this.init();
        },
        getBidStatus(val) {
            this.form.supplierBidStatusList = val;
        },
        handleSizeChange(val) {
            this.form.pageNo = 1;
            this.form.pageSize = val;
            this.init();
        },
        handleCurrentChange(val) {
            this.form.pageNo = val;
            this.init();
        },
        // 弹框分页
        fileSizeChange(val) {
            this.page.pageSize = val;
            this.popupReq();
        },
        fileCurrentChange(val) {
            this.page.pageNo = val;
            this.popupReq();
        }
    },
    computed: { // 获取vuex
        loginState: function() {
            return this.$store.state.bidData;
        },
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode'])
    }
};
</script>
<style lang="less">
.bid-query {
    .bid-top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    }

    .demo-export{
        .el-button--defult{
            color: #fff;
            background-color: #00bcbf;
        }
    }

    .bid-top-left {
        display: flex;
        align-items: center;
        .select {
            margin-right:10px;
            width:160px;

            &.otp-select {
                width: 220px;
            }
        }
    }
    .btn-span{margin-right: 10px;}

    .bid-top-right {
        display: flex;
        justify-content: center;
        align-items: center;

        .demo-export {
            margin-top: 2px;
            margin-right: 5px;
        }

        .el-button--mini {
            padding: 6.4px 10px;
            font-size: 12px;
            border: none;
        }

        .el-icon-upload2 {
            font-size: 15px;
            color: #fff;
        }
    }
    .action-btn{margin-right: 10px;}

    .load-info {
        font-size: 14px;
    }

    .bid-table {
        .el-table {
            min-height: calc(~"100vh - 350px");
            max-height: calc(~"100vh - 350px");
        }
        .uploadFile{font-size: 12px;color:#00bcbf}
    }

    .dialog-footer-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .el-table--border{ border: 1px solid #ebeef5;}
    .btn-del{margin-left: 10px;}
    .fqbjTipsCount{
        color: red;
        font-size: 12px;
    }
}
</style>